export default function SectionTitle({text, componentStyle, link}){

    return(<p className={componentStyle}>
        {text}
    </p>)

}